import { generateClient, GraphQLResult } from "aws-amplify/api";
// @ts-ignore
import { batchGetRevisionsByFormGroup } from "../graphql/queries";
import { recordSentry } from "utils/recordSentry";
import { Revision } from "db/definitions";

/**
 * Gets all the revisions by the formGroup id.
 * @param formGroupId FormGroup id that the revision is related to.
 * @returns revisions
 */
async function batchRetrieveRevisionsByFormGroup(formGroupId: string): Promise<Revision[]> {
	const items = [];
	try {
		let nextToken;
		while (nextToken !== null) {
			try {
				interface QueryResponse {
					revisionsByFormGroup: {
						items: Revision[];
						nextToken: string | null;
					};
				}
				const client = generateClient({ authMode: "userPool" });
				const result = (await client.graphql({
					query: batchGetRevisionsByFormGroup,
					variables: { formGroup: formGroupId, nextToken },
					authMode: "userPool",
				})) as GraphQLResult<QueryResponse>;
				const revisionArray = result.data.revisionsByFormGroup.items || [];
				for (const revision of revisionArray) {
					items.push(revision);
				}
				nextToken = result.data.revisionsByFormGroup.nextToken;
			} catch (err) {
				recordSentry({ error: err, msg: "ERROR GETTING REVISIONS BY FORMGROUP" });
				nextToken = null;
			}
		}
	} catch (error) {
		recordSentry({ error });
	}
	return items;
}

export default batchRetrieveRevisionsByFormGroup;
